module.exports = __webpack_public_path__ + "static/img/philips_hq.e8708d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code/philips_hq.jpg
// module id = Q3wF
// module chunks = 0